
export enum RoleType {
    Admin = 'Admin',
    SecuritySupervisior = 'SecuritySupervisior'

}

export enum ComponentName {
  Users = 'Users',
  
}
export enum ModalSize{
    Large = 'modal-lg',
    Small = 'modal-sm',
    XLarge='modal-xl',
    Medium='modal-md' 
}
export enum OnStatus{
    Active='Active',
    Inactive='Inactive'
}

